import type { IconSvgObject } from './types';

const ManIcon: IconSvgObject = [
  ["path", { d: "M16 16V10.5C16 9.39543 15.1046 8.5 14 8.5H10C8.89543 8.5 8 9.39543 8 10.5V16H10V22H14V16H16Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14 4C14 5.10457 13.1046 6 12 6C10.8954 6 10 5.10457 10 4C10 2.89543 10.8954 2 12 2C13.1046 2 14 2.89543 14 4Z", stroke: "currentColor", strokeLinecap: "square", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ManIcon;
